import jsPDF from 'jspdf';

const Convert_HTML_To_PDF = () => {
  var doc = new jsPDF({
    orientation: 'landscape',
  });

  // Source HTMLElement or a string containing HTML.
  var elementHTML = document.querySelector('#contentToPrint');

  doc.html(elementHTML, {
    callback: function (doc) {
      // Save the PDF
      doc.save('document.pdf');
    },
    // margin: [10, 10, 10, 10],
    autoPaging: 'text',
    x: 10,
    y: 10,
    width: 280, //target width in the PDF document
    windowWidth: 1500, //window width in CSS pixels
  });
};

export default Convert_HTML_To_PDF;
